import i18n from 'i18n-js';

import { SEND_STATUS } from '@helpers';
import { SEND_STATUS_CONTENT_KIND } from '@components/search/operations/components/StartJobPopup/components/SendStatus/constants';
import type { SendStatusInput, SendStatusContent } from '@components/search/operations/components/StartJobPopup/types';

export const resolveSendStatusContent = ({ status, id, messageStorage }: SendStatusInput): SendStatusContent => {
  switch (status) {
    case SEND_STATUS.Sending:
      return { kind: SEND_STATUS_CONTENT_KIND.Pending, label: i18n.t('Sending favorite version to folder on Machine...'), color: 'Label/Light/Tertiary' };
    case SEND_STATUS.UploadingError:
      return { kind: SEND_STATUS_CONTENT_KIND.Text, label: i18n.t('Error during uploading'), color: 'Label/Light/Warning' };
    case SEND_STATUS.Uploading:
      return { kind: SEND_STATUS_CONTENT_KIND.Pending, label: i18n.t('Uploading...'), color: 'Label/Light/Tertiary' };
    case SEND_STATUS.Sent:
      return {
        kind: SEND_STATUS_CONTENT_KIND.Pending,
        label: i18n.t('Sent to folder {{folder}}: on Machine', { folder: messageStorage[id] || 'Unknown' }),
        color: 'Label/Light/Tertiary',
      };
    case SEND_STATUS.Finish:
      return { kind: SEND_STATUS_CONTENT_KIND.Badge };
    default:
      return null;
  }
};
